import style from './block.module.scss';
import { ReactComponent as Facebook } from './facebook.svg';
import { ReactComponent as Instagram } from './instagram.svg';
import { ReactComponent as Tiktok } from './tiktok.svg';
import { ReactComponent as Twitter } from './twitter.svg';
import { ReactComponent as Youtube } from './youtube.svg';
import { ReactComponent as Linkedin } from './Linkedin.svg';

export const Socials = ({ links }) => {
    return (
        <div className={style.socials}>
            {links.facebook && (
                <div className={style.social}>
                    <a href={links.facebook} target="_blank" rel="noreferrer">
                        <Facebook />
                    </a>
                </div>
            )}
            {links.instagram && (
                <div className={style.social}>
                    <a href={links.instagram} target="_blank" rel="noreferrer">
                        <Instagram />
                    </a>
                </div>
            )}
            {links.twitter && (
                <div className={style.social}>
                    <a href={links.twitter} target="_blank" rel="noreferrer">
                        <Twitter />
                    </a>
                </div>
            )}
            {links.tiktok && (
                <div className={style.social}>
                    <a href={links.tiktok} target="_blank" rel="noreferrer">
                        <Tiktok />
                    </a>
                </div>
            )}
            {links.youtube && (
                <div className={style.social}>
                    <a href={links.youtube} target="_blank" rel="noreferrer">
                        <Youtube />
                    </a>
                </div>
            )}
            {links.linkedin && (
                <div className={style.social}>
                    <a href={links.linkedin} target="_blank" rel="noreferrer">
                        <Linkedin />
                    </a>
                </div>
            )}
        </div>
    );
};
